import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DocumentVerificationList } from '@app/_models/DocumentVerificationList';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-verifier-rejected-request',
  templateUrl: './verifier-rejected-request.component.html',
  styleUrls: ['./verifier-rejected-request.component.css']
})
export class VerifierRejectedRequestComponent implements OnInit {

  dtTrigger: Subject<any> = new Subject<any>();
  request: DocumentVerificationList[];
  dtOptions: DataTables.Settings = {};
  rejectionTrail

  @ViewChild('showModalBoxTEstingMagnify', { read: TemplateRef }) showModalBoxTEstingMagnify: TemplateRef<any>;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;
  @ViewChild('showRejectionTrailBox', { read: TemplateRef}) showRejectionTrailBoxTemplate: TemplateRef<any>;

  constructor(
    private documentVerificationListService: DocumentVerificationListService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
  ) { }

  openPdf() {
    window.open(this.fileURL);
  }

  openPdf1() {
    window.open(this.fileURL1);
  }

  fetchRejectionTrail(){
    console.log("-----Rejection Trail------", this.getId)
    this.modalService.open(this.showRejectionTrailBoxTemplate, { windowClass: 'my-class', size: 'sm', centered: true });
    this.documentVerificationListService.getRejectionReason(this.getId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response--rejection-", data)
          this.rejectionTrail = data.respData;
          console.log(this.rejectionTrail)
          // this.dtTrigger.next();
        },
        error => {
          console.log("error === ",error)
        }
      )
  }

  // openModal1(id) {

  //   this.modalService.open(this.showModalBoxTEstingMagnify, { size: 'xl', centered: true });
  //   //this.magnify('uploadImg1', 3);
  // }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };

    // this.documentVerificationListService.getDocumentVerificationList()
    //   .pipe(first())
    //   .subscribe(
    //     data => {
    //       console.log("response---", data)
    //       this.request = data.respData;
    //       console.log(this.request)
    //       this.dtTrigger.next();
    //     },
    //     error => {
    //       console.log(error)
    //     }
    //   )     

      this.documentVerificationListService.getVerificationRejectList()
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          console.log("request ====",this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      ) 
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  getId: number;
  isVrImage: boolean = false;
  isVrPdf: boolean = false;
  isImageR = false;
  isImageL = false;
  upload_doc_path: any = "/University/assets/images/No-results-found.jpg";
  originalDocUploadFilePath: any = "/University/assets/images/No-results-found.jpg";
  src;
  fileURL;
  noImage1 = false;
  noImage2 = false;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  fileURL1;
  src1;

  openModal(id) {
    this.getId = id;
    this.isVrImage = false;
    this.isVrPdf = false;

    this.isImageR = false;
    this.isImageL = false;

    this.upload_doc_path = '';
    this.originalDocUploadFilePath = '';
    this.documentVerificationListService.getverifydocument(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          console.log(environment.apiUrl + data.respData[0].upload_doc_path)
          this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].upload_doc_path).pipe(first())
            .subscribe(
              add => {
                console.log("addadd---", add, add.type)
                let reader = new FileReader();
                if (add.type == "application/pdf") {
                  this.isVrPdf = true;
                  this.isVrImage = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    var base64Array = this.upload_doc_path.substring(28);
                    console.log("=====base64Array===========", base64Array);
                    this.src = this._base64ToArrayBuffer(base64Array);
                    let file = new Blob([add], { type: 'application/pdf' });
                    this.fileURL = URL.createObjectURL(file);
                    // this.magnify('uploadImg1', 3);
                  }, false);
                } else {
                  this.isVrImage = true;
                  this.isVrPdf = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    this.noImage1 = false;
                    console.log(reader.result);
                    // this.magnify('uploadImg1', 3);
                  }, false);
                }

                console.log(this.isVrImage, this.isVrPdf,)
                if (add) {
                  reader.readAsDataURL(add);

                }
                this.isImageL = true;
                if (this.isVrPdf == true) {
                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }
                console.log("=======img===========L======", this.isImageR, this.isImageL);
                if (this.isImageL == true && this.isImageR == true) {
                  this.SpinnerService.hide();
                  // this.constVal = 0
                  // this.constValOriginal = 0
                  // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });

                  this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                }
              }, error => {
                this.SpinnerService.hide();
                // this.constVal = 0
                // this.constValOriginal = 0
                // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
                this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
                this.noImage1 = true;
                console.log(error)
              })
          if (data.respData[0].originalDocUploadFilePath != undefined) {
            this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].originalDocUploadFilePath).pipe(first())
              .subscribe(
                data2 => {
                  console.log("data2---", data2, data2.type)
                  let reader = new FileReader();
                  if (data2.type == "application/pdf") {
                    this.isUPdf = true;
                    this.isUImage = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      var base64Array = this.originalDocUploadFilePath.substring(28);
                      console.log("=====base64Array===========", base64Array);
                      this.src1 = this._base64ToArrayBuffer(base64Array);
                      let file = new Blob([data2], { type: 'application/pdf' });
                      this.fileURL1 = URL.createObjectURL(file);
                      // this.magnify('uploadImg2', 3);
                    }, false);
                  } else {
                    this.isUImage = true;
                    this.isUPdf = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      console.log(reader.result);
                      this.noImage2 = false;
                      // this.magnifyOriginal('uploadImg2', 3);
                    }, false);
                  }
                  console.log(this.isUImage, this.isUPdf, this.isVrImage, this.isVrPdf)
                  if (data2) {
                    reader.readAsDataURL(data2);
                    //this.magnify('uploadImg2', 3);
                  }
                  this.isImageR = true;
                  if (this.isUPdf == true) {
                    var al = window.open('', 'OPEN');
                    window.setTimeout(function () { al.close() }, 100);
                  }
                  console.log("=======img===========R======", this.isImageR, this.isImageL);
                  if (this.isImageL == true && this.isImageR == true) {
                    this.SpinnerService.hide();
                    // this.constVal = 0
                    // this.constValOriginal = 0
                    // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
                    this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                  }
                }),
              console.log(this.request)
          }
          else {
            this.isUPdf = false;
            this.isUImage = true;
            this.isImageR = true;
            this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg";
            this.noImage2 = true;
          }
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            // this.constVal = 0
            // this.constValOriginal = 0
            // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
            // this.magnify('uploadImg1', 3);this.magnify('uploadImg2', 3);
          }
        },
        error => {
          this.isUPdf = false;
          this.isUImage = true;
          this.isImageR = true;
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            // this.constVal = 0
            // this.constValOriginal = 0
            // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class' });
          }
          this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; // test server
          this.noImage2 = true;
          console.log(error)
        }
      )
    this.SpinnerService.show();
    // this.modalService.open(this.viewModalTemplate);

  }

}
